import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { authSelector, fetchUserInfo } from '@/services/authSlice';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { AsyncStatus, URL } from '@/types';

import Loader from './Loader';

export default function Auth() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { status } = useAppSelector(authSelector);

  useEffect(() => {
    dispatch(fetchUserInfo()).then((res) => {
      if (res.meta.requestStatus === 'rejected') {
        // 未ログイン（または期限切れで refresh も失敗）: 自前ログイン画面へ。戻り先を from に載せる（spec §3.5）
        navigate(URL.LOGIN, {
          replace: true,
          state: { from: location.pathname + location.search },
        });
      }
    });
  }, [location.pathname]);

  return status.fetch === AsyncStatus.LOADING ? (
    <Loader height="100vh" />
  ) : status.fetch === AsyncStatus.SUCCESS ? (
    <Outlet />
  ) : null;
}
